import { render, staticRenderFns } from "./BillingTopUpReceivePayment.vue?vue&type=template&id=31648142&"
import script from "./BillingTopUpReceivePayment.vue?vue&type=script&lang=js&"
export * from "./BillingTopUpReceivePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports